import React from 'react';

import { useAsyncEffect } from '@/hooks/useAsyncEffect';
import { isArrayOf } from '@/types/common-type-guards';
import { isNamedIdentified, NamedIdentified } from '@/types/namedIdentified';

export const useCountryStates = (country: string | undefined): readonly NamedIdentified[] => {
  const [states, setStates] = React.useState<readonly any[]>([]);

  const directory = React.useMemo((): string => country?.toLowerCase() ?? '', [country]);

  const fetchStates = React.useCallback(async (): Promise<readonly NamedIdentified[]> => {
    const response = await fetch(`/countries/${directory}/index.json`);
    const resolved = await response.json();
    if (!resolved) {
      return [];
    }

    if (isStatesExport(resolved)) {
      return resolved.states;
    }

    return [];
  }, [directory]);

  useAsyncEffect(async (): Promise<void> => {
    setStates(await fetchStates());
  }, [fetchStates]);

  return states;
};

const isStatesExport = (obj: unknown): obj is { readonly states: readonly NamedIdentified[] } => {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  return 'states' in obj && isArrayOf(obj.states, isNamedIdentified);
};
